/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useBranding` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/

import { brandings } from 'src/config/brandings/index.js'
import { DEFAULT_BRANDING } from 'src/config/constants.ts'

const brandingMixin = {
  computed: {
    publicPath () {
      return import.meta.env.BASE_URL
    },
    branding () {
      return this.$store.getters['schoolBranding/getBranding']
    },
    brandingConfig () {
      return this.$store.getters['schoolBranding/getBrandingConfig']
    },
    brandingKeys () {
      return Object.keys(brandings)
    }
  },

  methods: {
    getImage (image) {
      return this.publicPath + image
    },
    getBrandedUrl (path, explicitBranding) {
      const url = new URL(path, import.meta.env.VITE_LIVE_UPDATE_ENABLED === 'true' ? import.meta.env.VITE_APP_URL : location.origin)
      const branding = explicitBranding || this.branding

      if (this.branding === DEFAULT_BRANDING) return url.href

      url.searchParams.append('branding', branding)

      return url.href
    }
  }
}

export default brandingMixin
